var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'infoBubble',
    _vm.info.pos ? _vm.info.pos : 'top',
    _vm.info.color ? _vm.info.color : '' ],style:(_vm.infoStyle)},[_c('div',[_vm._l((_vm.slotNames),function(v){return _vm._t(v,null,{"row":_vm.info.row,"col":_vm.info.col,"id":_vm.id})})],2),_c('hr',{staticClass:"mask",on:{"click":function($event){return _vm.$emit('close')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }